/**
 * @file Renders a note's last-updated stamp.
 */
import React from "react";
import { Space, Typography } from "antd";
import type { CSSProperties } from "react";

import Identity from "@components/Identity";
import { W0, W2 } from "@components/Constants";
import { Value } from "@components/Text";

const LABEL_BY = "by";
const LABEL_LAST_UPDATED = "Last updated on";

const STAMP_SPACE_SIZE = 6;

const FOOTER_TOP_OFFSET = 4;
const FOOTER_HEIGHT = 24;
const FOOTER_LEFT_MARGIN_STEPS = 3;

const FOOTER_STYLE: CSSProperties = {
  top: W0 + FOOTER_TOP_OFFSET,
  height: FOOTER_HEIGHT,
  position: "relative",
  marginLeft: W2 * FOOTER_LEFT_MARGIN_STEPS,
};

type Props = {
  updatedAt?: string;
  updatedBy?: string;
};

/**
 * Renders a note's last-updated stamp, when the note has one.
 */
const Footer = ({
  updatedAt,
  updatedBy,
}: Props): JSX.Element => {
  const hasStamp = !!updatedAt;

  return (
    <div style={FOOTER_STYLE}>
      {
        hasStamp && (
          <Space size={STAMP_SPACE_SIZE}>
            <Typography.Text>
              {LABEL_LAST_UPDATED}
            </Typography.Text>

            <Value value={updatedAt} />
            {LABEL_BY}
            <Identity id={updatedBy} />
          </Space>
        )
      }
    </div>
  );
};

export default Footer;
